// 快捷选择
const dateShortcuts = [
  {
    text: '今天',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 0)
      return [startDate, endDate]
    }
  },
  {
    text: '一星期',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 7)
      return [startDate, endDate]
    }
  },
  {
    text: '两星期',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 14)
      return [startDate, endDate]
    }
  },
  {
    text: '一个月',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setMonth(endDate.getMonth() - 1)
      return [startDate, endDate]
    }
  },
  {
    text: '三个月',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setMonth(endDate.getMonth() - 3)
      return [startDate, endDate]
    }
  },
  {
    text: '近半年',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setMonth(endDate.getMonth() - 6)
      return [startDate, endDate]
    }
  },
  {
    text: '近一年',
    onClick: () => {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setFullYear(endDate.getFullYear() - 1)
      return [startDate, endDate]
    }
  }
]

const timeShortcuts = [
  {
    text: '今天',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1)
      return [startDate, endDate]
    }
  },
  {
    text: '一星期',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 7)
      return [startDate, endDate]
    }
  },
  {
    text: '两星期',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date()
      startDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 14)
      return [startDate, endDate]
    }
  },
  {
    text: '一个月',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date(new Date().toLocaleDateString())
      startDate.setMonth(endDate.getMonth() - 1)
      return [startDate, endDate]
    }
  },
  {
    text: '三个月',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date(new Date().toLocaleDateString())
      startDate.setMonth(endDate.getMonth() - 3)
      return [startDate, endDate]
    }
  },
  {
    text: '近半年',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date(new Date().toLocaleDateString())
      startDate.setMonth(endDate.getMonth() - 6)
      return [startDate, endDate]
    }
  },
  {
    text: '近一年',
    onClick: () => {
      const endDate = new Date(new Date().toLocaleDateString())
      endDate.setTime(endDate.getTime() + 3600 * 1000 * 24 * 1)
      const startDate = new Date(new Date().toLocaleDateString())
      startDate.setFullYear(endDate.getFullYear() - 1)
      return [startDate, endDate]
    }
  }
]
export {
  dateShortcuts,
  timeShortcuts
}
